import React from 'react';
import Hero from '../components/Hero';
import GuidesSection from '../components/GuidesSection';
import SocialProof from '../components/SocialProof';
import Reviews from '../components/Reviews';
import BlogSection from '../components/BlogSection';
import Newsletter from '../components/Newsletter';

const Home = () => {
  return (
    <main data-testid="home-page">
      <Hero />
      <GuidesSection />
      <SocialProof />
      <Reviews />
      <BlogSection />
      <Newsletter />
    </main>
  );
};

export default Home;
